export const formatGameDate = (gameDate) => {
  if (!gameDate || typeof gameDate !== "string") {
    return "Invalid Date";
  }

  // Parse the date as UTC
  const date = new Date(gameDate);
  if (isNaN(date.getTime())) {
    return "Invalid Date";
  }

  const months = [
    "JAN",
    "FEB",
    "MAR",
    "APR",
    "MAY",
    "JUN",
    "JUL",
    "AUG",
    "SEP",
    "OCT",
    "NOV",
    "DEC",
  ];

  // Use UTC methods to extract date components
  const day = String(date.getUTCDate()).padStart(2, "0");
  const month = months[date.getUTCMonth()];

  return `${day} ${month}`;
};

export const formatGameTime = (gameTime) => {
  if (!gameTime || typeof gameTime !== "string") {
    return "Invalid Time";
  }

  const [hours, minutes] = gameTime.split(":").map(Number);
  if (isNaN(hours) || isNaN(minutes)) {
    return "Invalid Time";
  }

  const period = hours >= 12 ? "pm" : "am";
  const formattedHours = hours % 12 || 12;
  const formattedMinutes = String(minutes).padStart(2, "0");

  return `${formattedHours}:${formattedMinutes}${period}`;
};

const DAYS_ES = [
  "Domingo",
  "Lunes",
  "Martes",
  "Miércoles",
  "Jueves",
  "Viernes",
  "Sábado",
];

/** Local calendar date as YYYY-MM-DD (not UTC — evening games stay "today"). */
export const localISODate = (date = new Date()) => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
};

/** "Lunes" for a YYYY-MM-DD string (parsed as a calendar date, no TZ shift). */
export const weekdayName = (isoDate) => {
  const [y, m, d] = String(isoDate || "")
    .slice(0, 10)
    .split("-")
    .map(Number);
  if (!y || !m || !d) return "";
  const date = new Date(y, m - 1, d);
  return Number.isNaN(date.getTime()) ? "" : DAYS_ES[date.getDay()];
};

/** "Lunes 28 SEP" */
export const formatDayLabel = (isoDate) => {
  const day = weekdayName(isoDate);
  const date = formatGameDate(String(isoDate || "").slice(0, 10));
  return day ? `${day} ${date}` : date;
};
